import { translations } from 'services';

export default (status = '') => translations(status.replace('TRANSPORT_ADD_SUBMISSION_STATUS_', 'front.passing.submission_status.'));
